export default __webpack_public_path__ + "static/media/icon-essbar.9fd42840.svg";